import React from 'react';
import SEO from '../components/SEO';
import './About.scss';

const PrivacyPolicy: React.FC = () => {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Tanda Grampanchayat',
    description:
      'तांडा ग्रामपंचायत - गोंदिया जिल्ह्यातील गोंदिया तालुक्यातील आधिकारिक ग्रामपंचायत',
    url: 'https://gptandagondia.org.in',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Tanda',
      addressLocality: 'Gondia',
      addressRegion: 'Gondia',
      postalCode: '441601',
      addressCountry: 'IN',
    },
  };

  return (
    <div className="about-page">
      <SEO
        title="गोपनीयता धोरण | तांडा ग्रामपंचायत"
        description="तांडा ग्रामपंचायतच्या अधिकृत वेबसाइटवरील गोपनीयता धोरण – कोणती माहिती गोळा केली जाते, ती कशी वापरली जाते आणि सुरक्षा व कायदेशीर बाबींबद्दल सविस्तर माहिती."
        keywords="गोपनीयता धोरण, Privacy Policy, तांडा ग्रामपंचायत, वेबसाइट गोपनीयता, डेटा सुरक्षा"
        ogTitle="गोपनीयता धोरण | तांडा ग्रामपंचायत"
        ogDescription="तांडा ग्रामपंचायतच्या वेबसाइटवरील वैयक्तिक माहितीच्या वापर आणि सुरक्षेबद्दल गोपनीयता धोरण."
        canonicalUrl="https://gptandagondia.org.in/privacy-policy"
        structuredData={structuredData}
      />
      <div className="about-container">
        <h1>गोपनीयता धोरण</h1>

        <p>
          हे गोपनीयता धोरण तांडा ग्रामपंचायत (`"आम्ही"`, `"आमचा"`) या अधिकृत वेबसाइटवर
          ("वेबसाइट") भेट देणाऱ्या सर्व वापरकर्त्यांवर (`"आपण"`) लागू आहे. कृपया हे धोरण
          काळजीपूर्वक वाचा; वेबसाइटचा वापर केल्यास आपण या अटी मान्य करता.
        </p>

        <h2>१. आम्ही कोणती माहिती गोळा करू शकतो?</h2>
        <p>सामान्यतः आम्ही खालील प्रकारची मर्यादित माहिती गोळा करू शकतो:</p>
        <ul>
          <li>नाव, मोबाईल क्रमांक, ई-मेल आयडी (उदा. संपर्क फॉर्म भरताना)</li>
          <li>आपण दिलेली तक्रार, सूचना किंवा अभिप्राय यांसंबंधित मजकूर</li>
          <li>तांत्रिक माहिती जसे की IP पत्ता, ब्राउझर प्रकार, वापरलेले उपकरण इ.</li>
        </ul>

        <h2>२. माहितीचा उपयोग कशासाठी केला जातो?</h2>
        <p>आपली माहिती खालील उद्देशांसाठी वापरली जाऊ शकते:</p>
        <ul>
          <li>आपल्या तक्रारींना, सूचनांना किंवा प्रश्नांना उत्तर देण्यासाठी</li>
          <li>ग्रामपंचायतीच्या सेवा आणि वेबसाइटचा दर्जा सुधारण्यासाठी</li>
          <li>तांत्रिक अडचणी समजून घेऊन सुरक्षा व कार्यक्षमता सुधारण्यासाठी</li>
        </ul>

        <h2>३. माहिती तृतीय पक्षांसोबत शेअर करणे</h2>
        <p>
          आम्ही आपली वैयक्तिक माहिती कोणत्याही तृतीय पक्षास विक्री, भाड्याने किंवा
          व्यावसायिक फायद्यासाठी शेअर करत नाही. केवळ खालील परिस्थितींमध्ये मर्यादित
          स्वरूपात माहिती शेअर केली जाऊ शकते:
        </p>
        <ul>
          <li>कायद्याने किंवा न्यायालयीन आदेशानुसार आवश्यक असल्यास</li>
          <li>कायदेशीर कारवाई, फसवणूक किंवा सुरक्षेच्या दृष्टिकोनातून आवश्यक असल्यास</li>
        </ul>

        <h2>४. डेटा सुरक्षा</h2>
        <p>
          आपली माहिती सुरक्षित ठेवण्यासाठी योग्य प्रशासकीय आणि तांत्रिक उपाययोजना केली
          जाते. तथापि, इंटरनेटवर १००% सुरक्षा हमी देणे कोणत्याही संस्थेस शक्य नाही.
        </p>

        <h2>५. कुकीज (Cookies) आणि लॉग फाइल्स</h2>
        <p>
          वेबसाइटची कार्यक्षमता आणि वापर सुलभ करण्यासाठी मर्यादित कुकीज किंवा लॉग
          फाइल्सचा वापर केला जाऊ शकतो. आपण आपल्या ब्राउझरच्या सेटिंगद्वारे कुकीज
          नियंत्रित करू शकता; मात्र त्यामुळे वेबसाइटची काही वैशिष्ट्ये योग्यप्रकारे
          कार्य न करू शकतात.
        </p>

        <h2>६. अल्पवयीन वापरकर्ते</h2>
        <p>
          अल्पवयीनांनी (१८ वर्षांखालील) वेबसाइटचा वापर पालक किंवा पालकांच्या देखरेखीखाली
          करावा. वैयक्तिक माहिती पाठवण्यापूर्वी त्यांच्या पालकांची परवानगी घेणे
          शिफारसीय आहे.
        </p>

        <h2>७. इतर वेबसाइट्सचे दुवे</h2>
        <p>
          या वेबसाइटवर इतर सरकारी किंवा उपयुक्त वेबसाइट्सचे दुवे असू शकतात. त्या
          वेबसाइट्सच्या गोपनीयता धोरणाबद्दल आम्ही जबाबदार नाही. आपण संबंधित वेबसाइटचे
          धोरण स्वतंत्रपणे वाचावे.
        </p>

        <h2>८. धोरणातील बदल</h2>
        <p>
          हे गोपनीयता धोरण वेळोवेळी अद्यतनित केले जाऊ शकते. महत्त्वाचे बदल झाल्यास ते
          या पानावर प्रसिद्ध केले जातील. कृपया अद्ययावत माहितीकरिता हे पान कालांतराने
          तपासत राहा.
        </p>

        <h2>९. संपर्क</h2>
        <p>
          या गोपनीयता धोरणासंदर्भात काही शंका असल्यास, कृपया वेबसाइटवरील
          "संपर्क" विभागाद्वारे किंवा ग्रामपंचायत कार्यालयात प्रत्यक्ष भेट देऊन संपर्क
          साधा.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
